export default "__VITE_ASSET__BVRjFtyp__"